import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../models/user/user.model';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../services/toast/toast.service';
import { Observable } from 'rxjs';
import { Toast } from '../../services/toast/toast.model';
import { ToastType } from '../../services/toast/toast-type.enum';

@Component({
    selector: 'tvcore-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
	@Input()
	activeLanguage: string | null;
	@Input()
	brand: string;
	@Input()
	customHome?: string[];
	@Input()
	customQuery?: any;
	@Input()
	disableHome: boolean = false;
	@Input()
	logo: string;
	@Input()
	logoAlt: string;
	@Input()
	languages: string[] = ['nl'];
	@Input()
	unbrand: boolean = false;
	@Input()
	user: User | null = null;
	@Output()
	changeLanguage: EventEmitter<string> = new EventEmitter<string>();
	@Output()
	logout: EventEmitter<void> = new EventEmitter();

	toast$: Observable<Toast>;

	readonly ToastType = ToastType;

	constructor(private route: ActivatedRoute, private toastService: ToastService) {}

	ngOnInit() {
		const langUrl = this.route.snapshot.queryParamMap.get('lang');
		this.setLang(langUrl);

		const langSession = localStorage.getItem('lang');
		this.setLang(langSession);

		this.toast$ = this.toastService.toast$;
	}

	doLogout() {
		this.logout.emit();
	}

	closeToast() {
		this.toastService.clear();
	}

	setLang(lang: string | null) {
		if (lang && this.languages.find((l) => l === lang)) {
			this.changeLanguage.emit(lang);
			localStorage.setItem('lang', lang);
		}
	}
}
